"use strict";
(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/scripts/components/custom-tabs.js
  var CustomTabs = class {
    constructor(container) {
      this.container = container;
      this.tabList = this.container.querySelector(".js-tablist");
      this.tabLinks = this.container.querySelectorAll(".js-tablist__link");
      this.tabPanels = this.container.querySelectorAll(".js-tabcontent");
      this.init();
    }
    init() {
      if (!this.tabList || !this.tabLinks.length || !this.tabPanels.length) {
        console.warn("CustomTabs: Required elements not found", {
          tabList: !!this.tabList,
          tabLinks: this.tabLinks.length,
          tabPanels: this.tabPanels.length
        });
        return;
      }
      this.setupAccessibility();
      this.bindEvents();
      this.activateFirstTab();
    }
    setupAccessibility() {
      this.tabList.setAttribute("role", "tablist");
      this.tabLinks.forEach((link, index) => {
        const panel = this.tabPanels[index];
        const tabId = `tab-${this.container.id || "custom"}-${index}`;
        const panelId = `panel-${this.container.id || "custom"}-${index}`;
        link.setAttribute("role", "tab");
        link.setAttribute("id", tabId);
        link.setAttribute("aria-selected", "false");
        link.setAttribute("aria-controls", panelId);
        link.setAttribute("tabindex", "-1");
        if (panel) {
          panel.setAttribute("role", "tabpanel");
          panel.setAttribute("id", panelId);
          panel.setAttribute("aria-labelledby", tabId);
          panel.setAttribute("aria-hidden", "true");
          panel.setAttribute("tabindex", "0");
        }
      });
    }
    bindEvents() {
      this.tabLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.activateTab(link);
        });
        link.addEventListener("keydown", (event) => {
          this.handleKeydown(event, link);
        });
      });
    }
    handleKeydown(event, currentTab) {
      const tabIndex = Array.from(this.tabLinks).indexOf(currentTab);
      let targetTab;
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          targetTab = this.tabLinks[tabIndex - 1] || this.tabLinks[this.tabLinks.length - 1];
          this.activateTab(targetTab);
          break;
        case "ArrowRight":
          event.preventDefault();
          targetTab = this.tabLinks[tabIndex + 1] || this.tabLinks[0];
          this.activateTab(targetTab);
          break;
        case "Home":
          event.preventDefault();
          this.activateTab(this.tabLinks[0]);
          break;
        case "End":
          event.preventDefault();
          this.activateTab(this.tabLinks[this.tabLinks.length - 1]);
          break;
      }
    }
    activateTab(selectedTab) {
      const selectedIndex = Array.from(this.tabLinks).indexOf(selectedTab);
      const selectedPanel = this.tabPanels[selectedIndex];
      if (!selectedPanel) {
        console.warn("CustomTabs: Panel not found for tab", selectedTab);
        return;
      }
      this.tabLinks.forEach((link, index) => {
        const isSelected = index === selectedIndex;
        link.setAttribute("aria-selected", isSelected);
        link.setAttribute("tabindex", isSelected ? "0" : "-1");
        if (isSelected) {
          link.setAttribute("data-selected", "1");
        } else {
          link.removeAttribute("data-selected");
        }
      });
      this.tabPanels.forEach((panel, index) => {
        const isSelected = index === selectedIndex;
        panel.setAttribute("aria-hidden", !isSelected);
        if (isSelected) {
          panel.removeAttribute("tabindex");
        } else {
          panel.setAttribute("tabindex", "-1");
        }
      });
      selectedTab.focus();
    }
    activateFirstTab() {
      const firstTab = this.tabLinks[0];
      if (firstTab) {
        this.activateTab(firstTab);
      }
    }
    // Public method to activate tab by index
    activateTabByIndex(index) {
      const tab = this.tabLinks[index];
      if (tab) {
        this.activateTab(tab);
      }
    }
    // Public method to activate tab by ID
    activateTabById(tabId) {
      const tab = this.container.querySelector(`#${tabId}`);
      if (tab) {
        this.activateTab(tab);
      }
    }
  };
  function initCustomTabs() {
    const tabContainers = document.querySelectorAll(".js-tabs");
    tabContainers.forEach((container) => {
      new CustomTabs(container);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomTabs);
  } else {
    initCustomTabs();
  }

  // src/scripts/sections/header.js
  var initCustomHeaderMenu = (section) => {
    class CustomHeaderMenu extends HTMLElement {
      constructor() {
        var _a, _b, _c, _d;
        super();
        this.header = section;
        this.detailsElem = this.querySelector("details");
        this.summaryElem = (_a = this.detailsElem) == null ? void 0 : _a.querySelector("summary");
        this.megaMenu = (_b = this.summaryElem) == null ? void 0 : _b.nextElementSibling;
        this.megaMenuList = (_c = this.megaMenu) == null ? void 0 : _c.querySelector("[data-mega-menu-level-2-list]");
        this.level2Links = (_d = this.megaMenuList) == null ? void 0 : _d.querySelectorAll(".header__menu-item--level-2");
        this.megaMenuBarHeight = getComputedStyle(this.header).getPropertyValue("--megamenu-level-2-bar-height");
      }
      connectedCallback() {
        this.initLevel1Listeners();
        this.initLevel2Listeners();
        this.openOnPageLoad();
      }
      initLevel1Listeners() {
        this.summaryElem.addEventListener("click", (event) => {
          var _a;
          event.preventDefault();
          const openedDetails = this.header.querySelector("custom-header-menu .open");
          if (!this.detailsElem.classList.contains("open")) {
            this.summaryElem.setAttribute("aria-expanded", true);
            this.detailsElem.setAttribute("open", true);
            requestAnimationFrame(() => {
              this.detailsElem.classList.add("open");
            });
          }
          if (openedDetails && openedDetails !== this.detailsElem) {
            openedDetails.classList.remove("open");
            (_a = openedDetails.querySelector("summary")) == null ? void 0 : _a.setAttribute("aria-expanded", false);
            requestAnimationFrame(() => {
              openedDetails.removeAttribute("open");
            });
          }
          requestAnimationFrame(() => {
            var _a2;
            (_a2 = this.level2Links[0]) == null ? void 0 : _a2.dispatchEvent(new MouseEvent("mouseenter"));
          });
          if (section.classList.contains("section-header--scrolling-down")) {
            section.scrollController.triggerDirection("up");
          }
        });
      }
      initLevel2Listeners() {
        var _a, _b;
        (_a = this.level2Links) == null ? void 0 : _a.forEach((level2Link) => {
          level2Link.addEventListener("mouseenter", () => {
            var _a2;
            const level2Menu = level2Link.nextElementSibling;
            const height = level2Menu ? `${level2Menu.scrollHeight + 48}px` : this.megaMenuBarHeight;
            this.closeExpandedLevel2Menu();
            (_a2 = level2Link.closest("li")) == null ? void 0 : _a2.classList.add("is-expanded");
            if (this.megaMenuList) {
              this.megaMenuList.style.height = height;
            }
          });
        });
        (_b = this.megaMenuList) == null ? void 0 : _b.addEventListener("mouseleave", () => {
          this.megaMenuList.style.height = `${this.megaMenuBarHeight}`;
          this.closeExpandedLevel2Menu();
        });
      }
      closeExpandedLevel2Menu() {
        var _a;
        const level2Expanded = (_a = this.megaMenuList) == null ? void 0 : _a.querySelector(".is-expanded");
        level2Expanded == null ? void 0 : level2Expanded.classList.remove("is-expanded");
      }
      openOnPageLoad() {
        if (!this.detailsElem || !this.summaryElem) return;
        let savedMenuID = sessionStorage.getItem("lastClickedMenuId");
        if (!savedMenuID) {
          const firstDetailsEl = this.header.querySelector("[data-header-menu-id]");
          savedMenuID = firstDetailsEl == null ? void 0 : firstDetailsEl.getAttribute("data-header-menu-id");
        }
        this.detailsID = this.detailsElem.getAttribute("data-header-menu-id");
        if (savedMenuID === this.detailsID) {
          this.detailsElem.setAttribute("open", true);
          this.detailsElem.classList.add("open");
          this.summaryElem.setAttribute("aria-expanded", "true");
        }
      }
    }
    if (!customElements.get("custom-header-menu")) {
      customElements.define("custom-header-menu", CustomHeaderMenu);
    }
  };
  var onDesktopScrollDirectionChange = (callback) => {
    let lastScrollTop = 0;
    let currentDirection = null;
    let ticking = false;
    const threshold = 20;
    const updateScrollDirection = (direction) => {
      if (direction !== currentDirection) {
        currentDirection = direction;
        callback(direction);
      }
    };
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const scrollTop = window.scrollY;
            const scrollDifference = Math.abs(scrollTop - lastScrollTop);
            if (scrollDifference > threshold) {
              const direction = scrollTop > lastScrollTop ? "down" : "up";
              updateScrollDirection(direction);
              lastScrollTop = scrollTop;
            }
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    return {
      triggerDirection: (direction) => {
        updateScrollDirection(direction);
        lastScrollTop = window.scrollY;
      }
    };
  };
  var initCustomHeader = (section) => {
    initCustomHeaderMenu(section);
    const setupNavLinkTracking = () => {
      const navSelector = window.matchMedia("(max-width: 989px)").matches ? "[data-header-drawer-nav]" : "[data-header-nav]";
      const nav = section.querySelector(navSelector);
      const navLinks = nav == null ? void 0 : nav.querySelectorAll("a");
      navLinks == null ? void 0 : navLinks.forEach((link) => {
        link.addEventListener("click", () => {
          const parent = link.closest("[data-header-menu-id]");
          if (!parent) return;
          const parentID = parent.getAttribute("data-header-menu-id");
          sessionStorage.setItem("lastClickedMenuId", parentID);
        });
      });
    };
    setupNavLinkTracking();
    const isMobileQuery = window.matchMedia("(max-width: 989px)");
    if (!isMobileQuery.matches) {
      const scrollController = onDesktopScrollDirectionChange((direction) => {
        section.classList.remove("section-header--scrolling-up", "section-header--scrolling-down");
        section.classList.add(`section-header--scrolling-${direction}`);
      });
      section.scrollController = scrollController;
    }
    let mobileNavInitialized = false;
    const openSavedMobilePanel = () => {
      const savedMenuID = sessionStorage.getItem("lastClickedMenuId");
      if (!savedMenuID) return;
      const panel = section.querySelector(`[data-header-menu-id="${savedMenuID}"]`);
      if (!panel) return;
      const panelID = panel.id;
      const tabLink = section.querySelector(`[aria-controls="${panelID}"]`);
      tabLink == null ? void 0 : tabLink.click();
    };
    const initMobileNavAccordions = () => {
      const nav = section.querySelector("[data-header-drawer-nav]");
      const navAccordions = nav == null ? void 0 : nav.querySelectorAll("details");
      const closeNavAccordion = (details, summaryElement, panelElement) => {
        if (!details || !summaryElement || !panelElement) return;
        details.classList.remove("open");
        panelElement.addEventListener("transitionend", function handler(event) {
          if (event.propertyName === "grid-template-rows") {
            details.removeAttribute("open");
            summaryElement.setAttribute("aria-expanded", false);
            panelElement.removeEventListener("transitionend", handler);
          }
        });
      };
      navAccordions == null ? void 0 : navAccordions.forEach((details) => {
        const summaryElement = details.querySelector("summary");
        const panelElement = summaryElement == null ? void 0 : summaryElement.nextElementSibling;
        if (!summaryElement || !panelElement) return;
        summaryElement.addEventListener("click", (event) => {
          var _a;
          event.preventDefault();
          const isOpen = details.classList.contains("open");
          const openedDetails = (_a = summaryElement.closest("[data-menu-drawer-menu]")) == null ? void 0 : _a.querySelector("details.open");
          if (openedDetails && openedDetails !== details) {
            const openedSummaryElement = openedDetails.querySelector("summary");
            const openedPanelElement = openedSummaryElement == null ? void 0 : openedSummaryElement.nextElementSibling;
            closeNavAccordion(openedDetails, openedSummaryElement, openedPanelElement);
          }
          if (!isOpen) {
            details.setAttribute("open", true);
            summaryElement.setAttribute("aria-expanded", true);
            requestAnimationFrame(() => {
              details.classList.add("open");
              if (openedDetails) {
                setTimeout(() => {
                  const rect = details.getBoundingClientRect();
                  if (rect.top >= 0 && rect.top <= window.innerHeight) return;
                  details.scrollIntoView({
                    behavior: "smooth"
                  });
                }, 350);
              }
            });
          } else {
            closeNavAccordion(details, summaryElement, panelElement);
          }
        });
      });
    };
    if (isMobileQuery.matches) {
      openSavedMobilePanel();
      initMobileNavAccordions();
      mobileNavInitialized = true;
    }
    isMobileQuery.addEventListener("change", (event) => {
      if (!event.matches || mobileNavInitialized) return;
      setupNavLinkTracking();
      openSavedMobilePanel();
      initMobileNavAccordions();
    });
  };
  var header_default = initCustomHeader;

  // src/scripts/components/tagalys-init.js
  var isTagalysConfigValid = ({ sdkUrl, serverUrl, clientCode, apiKey, storeId }) => sdkUrl && serverUrl && clientCode && apiKey && storeId;
  var isTagalysEnabled = ({ enable = false }) => enable;
  var setTagalysConfiguration = ({ enable, serverUrl, clientCode, apiKey, storeId }) => {
    var _a, _b, _c, _d;
    if (!enable || !serverUrl || !clientCode || !apiKey || !storeId) return;
    const language = (_a = window.theme.locale.isoCode) != null ? _a : "en";
    const country = (_b = window.theme.localization.country) != null ? _b : "NZ";
    window.Tagalys.setConfiguration({
      api: {
        serverUrl,
        credentials: {
          clientCode,
          apiKey
        },
        storeId
      },
      locale: `${language}-${country}`,
      currency: {
        displayFormatter: "{{currencyLabel}}{{value}}",
        code: (_c = window.theme.localization.currency) != null ? _c : "NZD",
        label: (_d = window.theme.localization.currencySymbol) != null ? _d : "$",
        fractionalDigits: 2,
        forceFractionalDigits: true
      },
      analyticsStorageConsentProvided() {
        return true;
      },
      track: true
    });
  };
  var setPlatformConfigurationForTagalys = ({ enable, storefrontApiAccessToken }) => {
    var _a, _b;
    if (!enable) return;
    const productMetafields = [
      {
        namespace: "card",
        key: "badge"
      },
      {
        namespace: "card",
        key: "message"
      }
    ];
    window.Tagalys.setPlatformConfiguration({
      platform: "Shopify",
      countryCode: (_a = window.theme.localization.country) != null ? _a : "NZ",
      baseCountryCode: (_b = window.theme.localization.baseCountry) != null ? _b : "NZ",
      useStorefrontAPIForSecondaryMarkets: Boolean(storefrontApiAccessToken),
      waitForStorefrontAPI: Boolean(storefrontApiAccessToken),
      storefrontAPI: {
        accessToken: storefrontApiAccessToken,
        myShopifyDomain: window.Shopify.shop
      },
      metafields: {
        products: productMetafields
      }
    });
  };
  var onTagalysReady = (callback) => {
    const checkTagalys = setInterval(() => {
      if (!window.Tagalys || !window.tagalysReady) {
        window.console.error("TWP | onTagalysReady | Tagalys is not ready");
        return;
      }
      clearInterval(checkTagalys);
      if (typeof callback === "function") {
        callback();
      }
    }, 150);
  };
  var initTagalys = () => {
    const tagalysConfig = window.theme.tagalys;
    if (!tagalysConfig || !isTagalysConfigValid(tagalysConfig) || !isTagalysEnabled(tagalysConfig)) {
      return;
    }
    const checkTagalys = setInterval(() => {
      if (!window.Tagalys) {
        window.console.error("TWP | tagalysInit | Tagalys has not loaded");
        return;
      }
      clearInterval(checkTagalys);
      setTagalysConfiguration(window.theme.tagalys);
      setPlatformConfigurationForTagalys(window.theme.tagalys);
      window.tagalysReady = true;
      document.dispatchEvent(new Event("tagalys:ready"));
    }, 150);
  };

  // src/scripts/utils/tagalys.js
  var constructLocalisedProductLink = (product) => {
    const marketRoot = window.theme.locale.rootUrl === "/" ? "" : window.theme.locale.rootUrl;
    return `${window.location.origin}${marketRoot}/products/${product.handle}`;
  };
  var decodeHtmlEntities = (text) => {
    if (!text) return "";
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  // src/scripts/utils/shopify-images.js
  var imageUrl = (url, width, height, crop) => {
    if (!url || !(width || height)) return null;
    if (width && typeof width !== "number") return null;
    if (height && typeof height !== "number") return null;
    if (crop && typeof crop !== "string") return null;
    try {
      const urlObj = new URL(url, window.location.origin);
      const params = urlObj.searchParams;
      const currentWidth = params.get("width");
      const currentHeight = params.get("height");
      const currentCrop = params.get("crop");
      if (!height && currentHeight) params.delete("height");
      if (!width && currentWidth) params.delete("width");
      if (!crop && currentCrop) params.delete("crop");
      if (width) params.set("width", width);
      if (height) params.set("height", height);
      if (crop) params.set("crop", crop);
      return urlObj.href;
    } catch (error) {
      return null;
    }
  };

  // src/scripts/components/responsive-image.js
  var responsiveImage = (image, imageAlt, maxWidth, lazyload = true, sizes = "", aspectRatio = "natural") => {
    const widths = [160, 320, 480, 640, 800, 960, 1120, 1280, 1440, 1600, 1920, 2240, 2560];
    let srcset = "";
    widths.forEach((width, index) => {
      if (width > maxWidth) return;
      const src = imageUrl(image.src, width);
      if (index > 0) {
        srcset += ", ";
      }
      srcset += `${src} ${width}w`;
    });
    return `
    <img
      class="component-image__image"
      src="${imageUrl(image.src, 480)}"
      srcset="${srcset}"
      loading="${lazyload ? "lazy" : "eager"}"
      sizes="${sizes}"
      width="${image.width}"
      height="${image.height}"
      alt="${imageAlt}"
    />`;
  };
  var responsive_image_default = responsiveImage;

  // src/scripts/components/product-card-template/product-card-media.js
  var renderProductCardMedia = (product, productLink) => {
    var _a, _b, _c;
    const imgAspectRatio = "2-3";
    const imgMaxWidth = "1120";
    const imgSizes = "(min-width: 61.875rem) 26.5vw, (min-width: 48rem) 35vw, 90vw";
    const imgDefaultAlt = product.title;
    const showSecondaryImages = (_b = (_a = window.theme) == null ? void 0 : _a.productCard) == null ? void 0 : _b.showSecondaryImages;
    const productImages = product.images;
    const featuredImage = productImages[0];
    const featuredImageAlt = (_c = featuredImage == null ? void 0 : featuredImage.alt) != null ? _c : imgDefaultAlt;
    const featuredImageMarkup = productImages.length > 1 ? `${responsive_image_default(featuredImage, featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}
    ${responsive_image_default(productImages[1], featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}` : `
    ${responsive_image_default(featuredImage, featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}`;
    let sliderMarkup = "";
    if (showSecondaryImages && product.images.length > 1) {
      let otherImagesMarkup = "";
      product.images.forEach((image, index) => {
        var _a2;
        if (index === 0) return;
        const imageAlt = (_a2 = image.alt) != null ? _a2 : imgDefaultAlt;
        otherImagesMarkup += `<div class="product-card__slide"><a href=${productLink}>${responsive_image_default(
          image,
          imageAlt,
          imgMaxWidth,
          true,
          imgSizes,
          imgAspectRatio
        )}</a></div>`;
      });
      sliderMarkup = `<div class="product-card__slider" data-slider>
      <div class="product-card__slide">${featuredImageMarkup}</div>
      ${otherImagesMarkup}
    </div>`;
    }
    if (sliderMarkup) {
      return sliderMarkup;
    }
    return featuredImageMarkup;
  };
  var product_card_media_default = renderProductCardMedia;

  // src/scripts/components/product-card-template/product-card-render.js
  var checkNotifyMeEnabled = (product) => {
    var _a, _b, _c;
    const hasNotifyMeTag = (_a = product.tags) == null ? void 0 : _a.some(
      (tag) => tag.toLowerCase() === "notify-me"
    );
    return ((_c = (_b = window.theme) == null ? void 0 : _b.notifyMe) == null ? void 0 : _c.enable) && hasNotifyMeTag;
  };
  var getSizeOption = (product) => {
    var _a;
    return (_a = product.options_with_values) == null ? void 0 : _a.find(
      (opt) => opt.name === "Size"
    );
  };
  var renderQuickAddDesktop = (product) => {
    var _a, _b, _c;
    const sizeOption = getSizeOption(product);
    const notifyMeEnabled = checkNotifyMeEnabled(product);
    const oneSizeLabel = ((_c = (_b = (_a = window.theme) == null ? void 0 : _a.strings) == null ? void 0 : _b.product) == null ? void 0 : _c.oneSize) || "One Size";
    if (!sizeOption) {
      const variant = product.variants[0];
      const isSoldOut = !variant.available;
      return `
      <button
        class="quick-add-inline-desktop__size-btn ${isSoldOut ? "quick-add-inline-desktop__size-btn--sold-out" : ""}"
        data-variant-id="${variant.id}"
        data-size="${oneSizeLabel}"
        data-product-id="${product.id}"
        type="button"
        ${isSoldOut && !notifyMeEnabled ? 'disabled aria-disabled="true"' : ""}
        ${isSoldOut && notifyMeEnabled ? `data-notify-me-trigger data-variant-id-notify="${variant.id}"` : ""}
        aria-label="${isSoldOut && notifyMeEnabled ? `Notify me when ${oneSizeLabel} is back in stock` : `Add ${oneSizeLabel} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text${isSoldOut && notifyMeEnabled ? " quick-add-inline-desktop__size-text--strikethrough" : ""}">${oneSizeLabel}</span>
        ${isSoldOut && notifyMeEnabled ? `
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        ` : '<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `;
    }
    return sizeOption.values.map((size) => {
      const variant = product.variants.find(
        (v) => v.option1 === size || v.option2 === size || v.option3 === size
      );
      if (!variant) return "";
      const isSoldOut = !variant.available;
      return `
      <button
        class="quick-add-inline-desktop__size-btn ${isSoldOut ? "quick-add-inline-desktop__size-btn--sold-out" : ""}"
        data-variant-id="${variant.id}"
        data-size="${size}"
        data-product-id="${product.id}"
        type="button"
        ${isSoldOut && !notifyMeEnabled ? 'disabled aria-disabled="true"' : ""}
        ${isSoldOut && notifyMeEnabled ? `data-notify-me-trigger data-variant-id-notify="${variant.id}"` : ""}
        aria-label="${isSoldOut && notifyMeEnabled ? `Notify me when size ${size} is back in stock` : `Add size ${size} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text${isSoldOut && notifyMeEnabled ? " quick-add-inline-desktop__size-text--strikethrough" : ""}">${size}</span>
        ${isSoldOut && notifyMeEnabled ? `
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        ` : '<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `;
    }).join("");
  };
  var renderQuickAddMobile = (product, helpers) => {
    var _a, _b, _c, _d;
    const sizeOption = getSizeOption(product);
    const notifyMeEnabled = checkNotifyMeEnabled(product);
    const oneSizeLabel = ((_c = (_b = (_a = window.theme) == null ? void 0 : _a.strings) == null ? void 0 : _b.product) == null ? void 0 : _c.oneSize) || "One Size";
    const productData = {
      id: product.id,
      title: product.title,
      vendor: product.vendor,
      price: helpers.formatCurrency(product.price),
      compareAtPrice: product.compare_at_price ? helpers.formatCurrency(product.compare_at_price) : null,
      handle: product.handle,
      aspectRatio: 2 / 3,
      // Fixed aspect ratio as per your requirement
      images: ((_d = product.images) == null ? void 0 : _d.slice(0, 5).map((img) => ({
        url: img.src,
        srcset: `${img.src}?w=250 250w, ${img.src}?w=500 500w, ${img.src}?w=750 750w, ${img.src}?w=1000 1000w`,
        alt: img.alt || "",
        width: img.width,
        height: img.height
      }))) || [],
      sizes: !sizeOption ? [{
        value: oneSizeLabel,
        variantId: product.variants[0].id,
        available: product.variants[0].available
      }] : sizeOption.values.map((size) => {
        const variant = product.variants.find(
          (v) => v.option1 === size || v.option2 === size || v.option3 === size
        );
        return variant ? {
          value: size,
          variantId: variant.id,
          available: variant.available
        } : null;
      }).filter(Boolean),
      variants: product.variants.map((v) => ({
        id: v.id,
        title: v.title,
        available: v.available
      })),
      notifyMeEnabled
    };
    return `
    <button
      class="quick-add-inline-mobile__trigger"
      aria-label="Quick add ${product.title}"
      data-quick-add-trigger
      data-product-id="${product.id}"
      data-product-json='${JSON.stringify(productData).replace(/'/g, "&#39;")}'
      type="button"
    >
      <svg class="icon icon--plus" viewBox="0 0 24 24" width="24" height="24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6 5H11.4V11.4H5V12.6H11.4V19H12.6V12.6H19V11.4H12.6V5Z" fill="currentColor"/>
      </svg>
    </button>
  `;
  };
  var renderQuickAddInline = (product, helpers) => {
    var _a, _b;
    if (!((_b = (_a = window.theme) == null ? void 0 : _a.quickAdd) == null ? void 0 : _b.enable)) return "";
    if (!product.variants || product.variants.length === 0) return "";
    const sizeOption = getSizeOption(product);
    const variantCount = sizeOption ? sizeOption.values.length : 1;
    let sizeClass = "";
    if (variantCount === 1) {
      sizeClass = " quick-add-inline-desktop__sizes--one-size";
    } else if (variantCount < 5) {
      sizeClass = " quick-add-inline-desktop__sizes--flex";
    }
    return `
    <quick-add-inline
      class="quick-add-inline"
      data-product-id="${product.id}"
      data-section-id="tagalys-${product.id}"
    >
      <div class="quick-add-inline__desktop small-hide">
        <div class="quick-add-inline-desktop">
          <div class="quick-add-inline-desktop__sizes${sizeClass}">
            ${renderQuickAddDesktop(product)}
          </div>
        </div>
      </div>
      <div class="quick-add-inline__mobile medium-up-hide">
        ${renderQuickAddMobile(product, helpers)}
      </div>
    </quick-add-inline>
  `;
  };
  var renderCardBadge = (tags) => {
    var _a;
    if (!(tags == null ? void 0 : tags.length)) return "";
    const badgeTags = tags.filter((tag) => tag.includes("label:"));
    if (badgeTags.length === 0) return "";
    return `
    <div class="card__badge ${(_a = window.theme) == null ? void 0 : _a.badgePosition}">
      ${badgeTags.map((tag) => {
      const badgeText = tag.replace("label:", "");
      return `<span class="badge">${badgeText}</span>`;
    }).join("")}
    </div>
  `;
  };
  var renderWishlistButton = (product) => {
    var _a, _b;
    if (!((_b = (_a = window.theme) == null ? void 0 : _a.wishlist) == null ? void 0 : _b.twpEnable)) return "";
    const wishlistProduct = product;
    wishlistProduct.featured_image = product.images[0].src;
    return `
    <div class="osc-css wrapper-button-collection">
      <div
        class="button-collection-wishlist button-${product.id}"
        data-product-id="${product.id}"
        data-has-only-variant="${product.has_only_default_variant}"
        data-product-title="${product.title}"
      >
        <span class="button-icon"></span>
        <span class="button-text"></span>
      </div>
    </div>
    <script type="application/json" id="ProductJson-${product.id}">
      ${JSON.stringify(product)}
    <\/script>
    <script type="application/json" id="OptionJson-${product.id}">
      ${JSON.stringify(product.options_with_values)}
    <\/script>
  `;
  };
  var renderCardMessage = (metafields) => {
    var _a, _b;
    if (!((_b = (_a = metafields == null ? void 0 : metafields.card) == null ? void 0 : _a.message) == null ? void 0 : _b.value)) return "";
    return `<div class="card__message caption">${metafields.card.message.value}</div>`;
  };
  var renderVendor = (vendor) => {
    if (!vendor) return "";
    return `
    <span class="visually-hidden">Vendor</span>
    <div class="caption-with-letter-spacing">${vendor}</div>
  `;
  };
  var renderPrice = (product, helpers, productPrice, productCompareAtPrice) => {
    var _a, _b, _c, _d, _e, _f;
    const isOnSale = helpers.isProductOnSale(productCompareAtPrice, productPrice);
    if (product.price_varies) {
      return `
      <span>
        ${(((_c = (_b = (_a = window.theme) == null ? void 0 : _a.strings) == null ? void 0 : _b.product) == null ? void 0 : _c.priceFrom) || "From {{ price }}").replace(
        "{{ price }}",
        helpers.formatCurrency(product.price_min || productPrice)
      )}
      </span>
    `;
    }
    const compareAtPriceHtml = isOnSale ? `
    <span class="visually-hidden">${((_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.product) == null ? void 0 : _f.regularPrice) || "Regular price"}</span>
    <s data-compare-price>${helpers.formatCurrency(productCompareAtPrice)}</s>
  ` : "";
    return `
    ${compareAtPriceHtml}
    <span data-product-price ${isOnSale ? 'class="product-card__sale-price"' : ""}>
      ${helpers.formatCurrency(productPrice)}
    </span>
  `;
  };
  var renderProductCard = (product, helpers) => {
    const templateOptions = helpers.getTemplateOptions("product");
    const productLink = templateOptions.productPageUrl(product);
    const productPrice = helpers.getPrice ? helpers.getPrice(product) : product.price;
    const productCompareAtPrice = helpers.getCompareAtPrice ? helpers.getCompareAtPrice(product) : product.compare_at_price;
    const isOnSale = helpers.isProductOnSale(product.compare_at_price, product.price);
    return `
    <div class="card-wrapper product-card-wrapper underline-links-hover product-card-wrapper-TWP">
      ${renderWishlistButton(product)}
      <div class="card card--standard card--media" style="--ratio-percent: 128.47826086956522%">
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 128.47826086956522%">
          <a href=${productLink} class="card__content full-unstyled-link">
            <div class="card__media">
              <div class="media media--transparent ${product.images.length > 1 ? "media--hover-effect" : ""}">
                ${product_card_media_default(product, productLink)}
                <span class="visually-hidden">${product.title}</span>
              </div>
            </div>
            ${renderCardBadge(product.tags)}
          </a>
          ${renderQuickAddInline(product, helpers)}
        </div>
        <div class="card__content">
          <div class="card__information">
            ${renderVendor(product.vendor)}
            <h3 class="card__heading">
              <a class="full-unstyled-link" href=${productLink}>${product.title}</a>
            </h3>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price ${isOnSale ? "price--on-sale" : ""}">
                <div class="price__container">
                  ${renderPrice(product, helpers, productPrice, productCompareAtPrice)}
                </div>
              </div>
              ${renderCardMessage(product.metafields)}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  };
  var product_card_render_default = renderProductCard;

  // src/scripts/components/tagalys-widget-templates.js
  var tagalysWidgetTemplates = (limit, widgetElem) => {
    var _a, _b, _c, _d, _e, _f;
    const sectionId = (_a = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a.sectionId;
    const sectionTitle = (_b = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b.title;
    const headingSize = (_d = (_c = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _c.headingSize) != null ? _d : "h5";
    const buttonLabel = (_e = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _e.buttonLabel;
    const buttonUrl = (_f = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _f.buttonUrl;
    return {
      widget: {
        options: {
          limit,
          displayFormat: "grid",
          includeTagalysCSS: false
        },
        render: (html, args) => {
          const props = args.props;
          const helpers = props.helpers;
          const products = helpers.getProducts();
          if (props.loading === false) {
            if (products.length === 0) {
              return null;
            }
            return html`
            <${args.templates.title} />
            <${args.templates.productList} />
            <${args.templates.button} />
          `;
          }
        }
      },
      title: {
        render: (html) => {
          if (sectionTitle) {
            return html`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${headingSize}">${sectionTitle}</h2>
            </div>
          `;
          }
          return html``;
        }
      },
      productList: {
        render: (html, args) => html`
        <slider-component class="slider-component-full-width">
          <${args.templates.products} />
          <${args.templates.carouselActions} />
        </slider-component>
      `
      },
      products: {
        render: (html, args) => {
          const props = args.props;
          const products = props.helpers.getProducts();
          return html`<ul
          id="Slider-${sectionId}"
          class="grid product-grid contains-card contains-card--product contains-card--standard grid--4-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek"
        >
          ${products.map(
            (product, index) => html`<li class="grid__item slider__slide scroll-trigger animate--slide-in">
                <${args.templates.product} key=${index} product=${product} />
              </li>`
          )}
        </ul> `;
        }
      },
      product: {
        options: {
          // Generate the product page URL using the product object
          productPageUrl(product) {
            return constructLocalisedProductLink(product);
          }
        },
        render: (html, args) => {
          const props = args.props;
          const product = props.product;
          const helpers = props.helpers;
          return html`<div
          class="tagalys-section__slide"
          id="Slide-${product.id}"
          dangerouslySetInnerHTML=${{
            __html: product_card_render_default(product, helpers)
          }}
        />`;
        }
      },
      carouselActions: {
        render: (html) => {
          var _a2, _b2, _c2, _d2, _e2, _f2;
          return html`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.accessibility) == null ? void 0 : _c2.previousSlide}"
            aria-controls="Slider-${sectionId}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(_f2 = (_e2 = (_d2 = window.theme) == null ? void 0 : _d2.strings) == null ? void 0 : _e2.accessibility) == null ? void 0 : _f2.nextSlide}"
            aria-controls="Slider-${sectionId}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `;
        }
      },
      button: {
        render: (html) => {
          if (buttonLabel && buttonUrl) {
            return html`
            <div class="product-recommendations__button">
              <a href="${buttonUrl}" class="button button--secondary">${buttonLabel}</a>
            </div>
          `;
          }
          return html``;
        }
      }
    };
  };
  var tagalys_widget_templates_default = tagalysWidgetTemplates;

  // src/scripts/components/tagalys-recommendations.js
  var selectors = {
    widget: '[data-tagalys-widget="recommendations"]'
  };
  var tagalysRecommendations = (widgetElem) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const recommendationId = (_a = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a.recommendationId;
    const productId = (_b = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b.productId;
    const widgetLimit = (_d = (_c = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _c.limit) != null ? _d : 8;
    if (!recommendationId || !productId) {
      window.console.error("TWP | tagalysSimilarProducts | recommendationId or productId is missing");
      return;
    }
    (_g = (_f = (_e = window.Tagalys) == null ? void 0 : _e.UIWidgets) == null ? void 0 : _f.Recommendations) == null ? void 0 : _g.init(selectors.widget, {
      recommendationId,
      productId,
      templates: tagalys_widget_templates_default(widgetLimit, widgetElem),
      callbacks: {
        afterInitialRender: () => {
          const sliderComponent = widgetElem.querySelector("slider-component");
          sliderComponent == null ? void 0 : sliderComponent.reinitialiseSlider();
        }
      }
    });
  };
  var initTagalysRecommendations = (widgetElem) => {
    onTagalysReady(() => tagalysRecommendations(widgetElem));
  };

  // src/scripts/sections/product-recommendations.js
  var sectionType = "product-recommendations-recently";
  var selectors2 = {
    tagalysWidget: '[data-tagalys-widget="recommendations"]',
    prevButton: "[data-prev-btn]",
    nextButton: "[data-next-btn]",
    recommendedWrapper: "[data-recommended-wrapper]",
    recommendedSliderContainer: "[data-recommended-slider]",
    productCard: "[data-product-card]",
    sliderDesktop: ".slider--desktop"
  };
  var productRecommendations = (section) => {
    const container = section.querySelector(`[data-section-type="${sectionType}"]`);
    const tagalysRecommendations2 = container.querySelector(selectors2.tagalysWidget);
    if (!tagalysRecommendations2) return;
    initTagalysRecommendations(tagalysRecommendations2);
  };

  // src/scripts/components/tagalys-search-suggestions.js
  var selectors3 = {
    searchInput: "[data-TWP-search-input]",
    featuredProductsWidget: '[data-tagalys-widget="featured-products-suggestions"]'
  };
  var renderProductsList = (html, args) => {
    const props = args.props;
    const products = props.helpers.getProducts();
    return html`<div>
    <ul class="TWP-predictive-search__results-list--products predictive-search__results-list list-unstyled">
      ${products.map((product) => {
      return html`
          <li class="predictive-search__list-item">
            <${args.templates.product} key=${product.id} product=${product} />
          </li>
        `;
    })}
    </ul>
  </div>`;
  };
  var renderProduct = (html, args) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    console.log("in the right place first");
    const props = args.props;
    const product = props.product;
    const helpers = props.helpers;
    const productOptions = helpers.getTemplateOptions("product");
    const productUrl = productOptions.productPageUrl(product);
    const badgeTags = product.tags ? (_a = product.tags) == null ? void 0 : _a.filter((tag) => tag.includes("label:")) : [];
    return html`
    <a
      href=${productUrl}
      class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text product-card-wrapper-TWP"
    >
      ${product.featured_image ? html`<img
            class="predictive-search__image"
            src="${product.featured_image.src}&width=340"
            srcset="
              ${product.featured_image.src}&width=160   160w,
              ${product.featured_image.src}&width=360   360w,
              ${product.featured_image.src}&width=533   533w,
              ${product.featured_image.src}&width=720   720w,
              ${product.featured_image.src}&width=940   940w,
              ${product.featured_image.src}&width=1066 1066w,
              ${product.featured_image.src}&width=2132 2132w
            "
            sizes="(min-width: 768px) 25vw, 30vw"
            width="${product.featured_image.width}"
            height="${product.featured_image.height}"
            alt="${(_b = product.featured_image.alt) != null ? _b : product.title}"
          />` : null}

      <div class="predictive-search__item-content">
        <span class="visually-hidden">${(_e = (_d = (_c = window.theme) == null ? void 0 : _c.strings) == null ? void 0 : _d.accessibility) == null ? void 0 : _e.vendor}</span>
        <div class="predictive-search__item-vendor caption-with-letter-spacing">${product.vendor}</div>

        <p class="predictive-search__item-heading paragraph--small">${product.title}</p>

        ${helpers.isProductOnSale(product.compare_at_price, product.price) ? html`
              <p class="price price--on-sale">
                <div class="price__sale">
                  <span class="visually-hidden">${(_g = (_f = window.theme) == null ? void 0 : _f.strings) == null ? void 0 : _g.regularPriceLabel}</span>
                  <s class="price-item price-item--regular">
                    ${helpers.formatCurrency(product.compare_at_price)}
                  </s>
                  <span class="visually-hidden">${(_i = (_h = window.theme) == null ? void 0 : _h.strings) == null ? void 0 : _i.salePriceLabel}</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${helpers.formatCurrency(product.price)}
                  </span>
                </div>
              </p>
            ` : html`
              <p class="price">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${helpers.formatCurrency(product.price)}</span>
                </div>
              </p>
            `}
      </div>

      ${badgeTags.length > 0 ? html`
            <div class="card__badge">
              ${badgeTags.map((tag) => {
      const badgeText = tag.replace("label:", "");
      return html`<span class="badge">${badgeText}</span>`;
    })}
            </div>
          ` : ""}
    </a>
  `;
  };
  var initTagalysSearchSuggestions = () => {
    onTagalysReady(() => {
      var _a, _b, _c;
      const searchInput = document.querySelector(selectors3.searchInput);
      if (!searchInput) return;
      const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : "";
      (_c = (_b = (_a = window.Tagalys) == null ? void 0 : _a.UIWidgets) == null ? void 0 : _b.SearchSuggestions) == null ? void 0 : _c.init(selectors3.searchInput, {
        searchResultsURL: `${rootUrl}${window.theme.routes.search}`,
        templates: {
          widget: {
            options: {
              includeTagalysCSS: false,
              request: {
                products: {
                  limit: 3
                },
                collections: {
                  limit: 5
                },
                pages: {
                  limit: 5
                }
              },
              inheritAlignmentElementWidth: false,
              position(inputDOMNode, widgetDOMNode) {
                const searchForm = inputDOMNode.parentElement;
                const widgetParent = widgetDOMNode.parentElement;
                searchForm.after(widgetParent);
                return false;
              }
            }
          },
          hint: {
            render(html) {
              return html``;
            }
          },
          clickSuggestions: {
            // Displayed before the user enters the minimum required characters
            render(html, args) {
              var _a2, _b2, _c2, _d, _e, _f;
              const props = args.props;
              const helpers = props.helpers;
              const recentAndPopularSearches = helpers.getRecentAndPopularSearches();
              const recentSearches = recentAndPopularSearches.recentSearches;
              const popularSearches = recentAndPopularSearches.popularSearches;
              return html`
              <div class="predictive-search__results-groups-wrapper">
                <div class="predictive-search__result-group">
                  ${recentSearches.length > 0 ? html`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.recentSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${recentSearches.map(
                (recentSearch) => html`
                                <li>
                                  <a
                                    href=${helpers.getLink(recentSearch.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${recentSearch.displayString}
                                    </span>
                                  </a>
                                </li>
                              `
              )}
                          </ul>
                        </div>
                      ` : null}
                  ${popularSearches.length > 0 ? html`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.search) == null ? void 0 : _f.popularSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${popularSearches.map(
                (popularSearch) => html`
                                <li>
                                  <a
                                    href=${helpers.getLink(popularSearch.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${popularSearch.displayString}
                                    </span>
                                  </a>
                                </li>
                              `
              )}
                          </ul>
                        </div>
                      ` : null}
                </div>
                <div class="predictive-search__result-group">
                  <${args.templates.featuredProductsSuggestions} />
                </div>
              </div>
            `;
            }
          },
          featuredProductsSuggestions: {
            render(html) {
              return html`<div
              className="featured-products-suggestions featured_products-wrapper"
              data-tagalys-widget="featured-products-suggestions"
            ></div>`;
            },
            callbacks: {
              afterInitialRender: () => {
                var _a2, _b2;
                const widgetId = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.tagalys) == null ? void 0 : _b2.featuredProductsWidget.id;
                if (!widgetId) return;
                window.Tagalys.UIWidgets.SmartWidget.init(selectors3.featuredProductsWidget, {
                  widgetId,
                  templates: {
                    widget: {
                      options: {
                        limit: 3,
                        displayFormat: "grid",
                        includeTagalysCSS: false
                      },
                      render: (html, args) => {
                        const props = args.props;
                        const helpers = props.helpers;
                        const products = helpers.getProducts();
                        if (props.loading === false) {
                          if (products.length === 0) {
                            return null;
                          }
                          return html` <${args.templates.products} /> `;
                        }
                      }
                    },
                    products: {
                      render: (html, args) => {
                        return renderProductsList(html, args);
                      }
                    },
                    product: {
                      render(html, args) {
                        return renderProduct(html, args);
                      }
                    }
                  }
                });
              }
            }
          },
          typeSuggestions: {
            // Displays suggestions (products, collections, pages) after user enters the minimum required characters
            render(html, args) {
              var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l;
              const props = args.props;
              const helpers = props.helpers;
              const response = helpers.getAPIResponse();
              const responseTotal = (_b2 = (_a2 = response == null ? void 0 : response.metadata) == null ? void 0 : _a2.products) == null ? void 0 : _b2.total;
              const searchTerm = props.helpers.getEnteredSearchQuery();
              const searchPageUrl = `${rootUrl}${window.theme.routes.search}?q=${searchTerm}`;
              return html`
              <div class="predictive-search__results-groups-wrapper">
                <!--------- TEXT SUGGESTIONS (collections and pages) --------->
                <div class="predictive-search__result-group">
                  ${helpers.hasTextSearchSuggestions() ? html` <${args.templates.textSuggestions} /> ` : null}
                </div>

                <!--------- PRODUCTS SUGGESTIONS --------->
                <div class="predictive-search__result-group">
                  <${args.templates.products} />
                </div>
              </div>

              <div class="predictive-search__search-for-button">
                ${responseTotal ? html`
                      <p class="predictive-search__results-count caption-with-letter-spacing hide--max-md">
                        ${responseTotal === 1 ? (_f = (_e = (_d = (_c2 = window.theme) == null ? void 0 : _c2.strings) == null ? void 0 : _d.search) == null ? void 0 : _e.resultsWithCount.one) == null ? void 0 : _f.replace("{{ count }}", responseTotal) : (_i = (_h = (_g = window.theme) == null ? void 0 : _g.strings) == null ? void 0 : _h.search) == null ? void 0 : _i.resultsWithCount.other.replace("{{ count }}", responseTotal)}
                      </p>
                    ` : null}

                <a
                  href=${encodeURI(searchPageUrl)}
                  class="predictive-search__item predictive-search__item--term button button--primary animate-arrow"
                >
                  <span data-predictive-search-search-for-text>${(_l = (_k = (_j = window.theme) == null ? void 0 : _j.strings) == null ? void 0 : _k.search) == null ? void 0 : _l.view_all}</span>
                </a>
              </div>
            `;
            }
          },
          textSuggestions: {
            render(html, args) {
              const props = args.props;
              const helpers = props.helpers;
              const textSuggestions = helpers.getTextSuggestions();
              return html`
              ${textSuggestions.map(
                (suggestion) => {
                  var _a2;
                  return html`
                  <div>
                    <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                      ${suggestion.section_title}
                    </h2>
                    <ul class="predictive-search__results-list list-unstyled">
                      ${(_a2 = suggestion.items) == null ? void 0 : _a2.map(
                    (item) => html`
                          <li class="predictive-search__list-item">
                            <a href=${item.link} class="predictive-search__item link link--text" tabindex="-1">
                              <span
                                class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                              >
                                ${item.displayString}
                              </span>
                            </a>
                          </li>
                        `
                  )}
                    </ul>
                  </div>
                `;
                }
              )}
            `;
            }
          },
          products: {
            render(html, args) {
              return renderProductsList(html, args);
            }
          },
          product: {
            render(html, args) {
              return renderProduct(html, args);
            }
          }
        },
        callbacks: {
          afterInitialRender: () => {
            const headerSection = document.querySelector(".section-header");
            const resultsContainer = document.querySelector(".tagalys-search-suggestions");
            if (!headerSection || !resultsContainer) return;
            const resultsMaxHeight = window.innerHeight - headerSection.getBoundingClientRect().bottom;
            resultsContainer.style.maxHeight = `${resultsMaxHeight}px`;
          }
        }
      });
    });
  };

  // src/scripts/components/tagalys-search-results.js
  var selectors4 = {
    widget: '[data-tagalys-widget="search-results"]',
    drawer: "[data-filters-drawer]",
    facetsVertical: "[data-facets-vertical]"
  };
  var tagalysSearchResults = (container) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha;
    const widgetElem = container.querySelector(selectors4.widget);
    if (!widgetElem) return;
    const isDesktop = window.matchMedia("(min-width: 990px)").matches;
    const itemsPerPage = (_a = widgetElem.dataset.limit) != null ? _a : 24;
    const noResultsWidgetId = (_b = widgetElem.dataset) == null ? void 0 : _b.noResultsWidget;
    const noResultsWidgetLimit = (_c = widgetElem.dataset.noResultsWidgetLimit) != null ? _c : 4;
    const filtersType = (_d = widgetElem.dataset.filtersType) != null ? _d : "horizontal";
    const showVerticalFilters = widgetElem.dataset.showVerticalFilters === "true";
    const searchFilterLabel = (_e = widgetElem.dataset.searchFilterLabel) == null ? void 0 : _e.toLowerCase();
    const showFilterResultsCount = widgetElem.dataset.showFilterResultsCount === "true";
    const defaultExpandedFilters = (_f = widgetElem.dataset.defaultExpandedFilters) != null ? _f : "";
    const showMoreNumber = isDesktop ? 10 : 5;
    (_Ha = (_h = (_g = window.Tagalys) == null ? void 0 : _g.UIWidgets) == null ? void 0 : _h.SearchResults) == null ? void 0 : _Ha.init(selectors4.widget, {
      templates: {
        widget: {
          options: {
            limit: itemsPerPage,
            includeTagalysCSS: false
          },
          labels: {
            searchResults: {
              heading: {
                standard: (_j = (_i = window.theme) == null ? void 0 : _i.strings.search) == null ? void 0 : _j.titleWithCount,
                corrected: (_l = (_k = window.theme) == null ? void 0 : _k.strings.search) == null ? void 0 : _l.titleCorrected,
                partialMatches: (_n = (_m = window.theme) == null ? void 0 : _m.strings.search) == null ? void 0 : _n.titlePartialMatches,
                noResults: (_p = (_o = window.theme) == null ? void 0 : _o.strings.search) == null ? void 0 : _p.noResults
              }
            },
            filters: {
              heading: (_u = (_t = (_s = (_r = (_q = window.theme) == null ? void 0 : _q.strings) == null ? void 0 : _r.search) == null ? void 0 : _s.filters) == null ? void 0 : _t.heading) != null ? _u : "Filter",
              selected: (_z = (_y = (_x = (_w = (_v = window.theme) == null ? void 0 : _v.strings) == null ? void 0 : _w.search) == null ? void 0 : _x.filters) == null ? void 0 : _y.selected) != null ? _z : "{{ count }} selected",
              maxPrice: (_E = (_D = (_C = (_B = (_A = window.theme) == null ? void 0 : _A.strings) == null ? void 0 : _B.search) == null ? void 0 : _C.filters) == null ? void 0 : _D.maxPrice) != null ? _E : "The highest price is {{ price }}",
              from: (_J = (_I = (_H = (_G = (_F = window.theme) == null ? void 0 : _F.strings) == null ? void 0 : _G.search) == null ? void 0 : _H.filters) == null ? void 0 : _I.from) != null ? _J : "From",
              to: (_O = (_N = (_M = (_L = (_K = window.theme) == null ? void 0 : _K.strings) == null ? void 0 : _L.search) == null ? void 0 : _M.filters) == null ? void 0 : _N.to) != null ? _O : "To",
              reset: (_T = (_S = (_R = (_Q = (_P = window.theme) == null ? void 0 : _P.strings) == null ? void 0 : _Q.search) == null ? void 0 : _R.filters) == null ? void 0 : _S.reset) != null ? _T : "Reset",
              clear: (_Y = (_X = (_W = (_V = (_U = window.theme) == null ? void 0 : _U.strings) == null ? void 0 : _V.search) == null ? void 0 : _W.filters) == null ? void 0 : _X.clear) != null ? _Y : "Clear",
              clearFilter: (_ba = (_aa = (_$ = (__ = (_Z = window.theme) == null ? void 0 : _Z.strings) == null ? void 0 : __.search) == null ? void 0 : _$.filters) == null ? void 0 : _aa.clearFilter) != null ? _ba : "Remove",
              clearAll: (_ga = (_fa = (_ea = (_da = (_ca = window.theme) == null ? void 0 : _ca.strings) == null ? void 0 : _da.search) == null ? void 0 : _ea.filters) == null ? void 0 : _fa.clearAll) != null ? _ga : "Remove all",
              apply: (_la = (_ka = (_ja = (_ia = (_ha = window.theme) == null ? void 0 : _ha.strings) == null ? void 0 : _ia.search) == null ? void 0 : _ja.filters) == null ? void 0 : _ka.apply) != null ? _la : "Apply",
              label: (_qa = (_pa = (_oa = (_na = (_ma = window.theme) == null ? void 0 : _ma.strings) == null ? void 0 : _na.search) == null ? void 0 : _oa.filters) == null ? void 0 : _pa.label) != null ? _qa : "Filter",
              buttonLabel: (_va = (_ua = (_ta = (_sa = (_ra = window.theme) == null ? void 0 : _ra.strings) == null ? void 0 : _sa.search) == null ? void 0 : _ta.filters) == null ? void 0 : _ua.buttonLabel) != null ? _va : "Filter"
            },
            sortOptions: {
              label: (_ya = (_xa = (_wa = window.theme) == null ? void 0 : _wa.strings) == null ? void 0 : _xa.search) == null ? void 0 : _ya.sortBy
            },
            resultsWithCount: {
              one: (_Ca = (_Ba = (_Aa = (_za = window.theme) == null ? void 0 : _za.strings) == null ? void 0 : _Aa.search) == null ? void 0 : _Ba.resultsWithCount) == null ? void 0 : _Ca.one,
              other: (_Ga = (_Fa = (_Ea = (_Da = window.theme) == null ? void 0 : _Da.strings) == null ? void 0 : _Ea.search) == null ? void 0 : _Fa.resultsWithCount) == null ? void 0 : _Ga.other
            }
          },
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            if (helpers.isInitialLoading()) {
              return html` <${args.templates.loader} /> `;
            }
            if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
              return html` <${args.templates.noResults} /> `;
            }
            if (filtersType === "vertical") {
              return html`
              <${args.templates.header} />

              <${args.templates.filtersVerticalCount} />

              <div class="facets-vertical">
                <${args.templates.filtersVertical} />

                <div class="product-grid-container" id="ProductGridContainer">
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${args.templates.appliedFilters} />
                  </div>
                  <div class="template-search__results collection TWP-collection" id="product-grid">
                    <${args.templates.products} />
                    <${args.templates.productListFooter} />
                  </div>
                </div>
              </div>
            `;
            }
            return html`
            <${args.templates.header} />
            <${args.templates.productListHeader} />
            <div class="product-grid-container" id="ProductGridContainer">
              <div class="template-search__results collection" id="product-grid">
                <${args.templates.products} />
                <${args.templates.productListFooter} />
              </div>
            </div>
          `;
          }
        },
        loader: {
          render(html) {
            return html`
            <div class="loading__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" />
              </svg>
            </div>
          `;
          }
        },
        header: {
          render(html, args) {
            return html`
            <div class="template-search__header page-width scroll-trigger animate--fade-in">
              <${args.templates.heading} />
            </div>
          `;
          }
        },
        heading: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const getHeadingBasedOnAPIResponse = () => {
              var _a2, _b2, _c2, _d2;
              let headingText;
              if (!helpers.getQuery()) {
                headingText = (_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.search) != null ? _d2 : "Search";
              } else if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
                headingText = labels.searchResults.heading.noResults.replace("{{ terms }}", helpers.getQuery());
              } else if (helpers.isPartialResults()) {
                headingText = labels.searchResults.heading.partialMatches.replace("{{searchTerm}}", helpers.getQuery());
              } else if (helpers.isSpellingCorrectedQuery()) {
                headingText = labels.searchResults.heading.corrected.replace("{{originalSearchTerm}}", helpers.getOriginalQuery()).replace("{{resultsCount}}", helpers.getTotalProductsCount()).replace("{{correctedSearchTerm}}", helpers.getQuery());
              } else {
                headingText = labels.searchResults.heading.standard.replace("{{resultsCount}}", helpers.getTotalProductsCount()).replace("{{searchTerm}}", helpers.getQuery());
              }
              return decodeHtmlEntities(headingText);
            };
            return html`<h1 class="h5 center">${getHeadingBasedOnAPIResponse()}</h1>`;
          }
        },
        productListHeader: {
          render(html, args) {
            return html`
            <div id="main-search-filters" class="facets-wrapper facets-wrapper-TWP page-width">
              <div class="TWP-facets-container--horizontal facets-container scroll-trigger animate--fade-in">
                <!---------- DESKTOP FILTERS ---------->
                <div class="facets small-hide">
                  <div class="facets__form">
                    <${args.templates.filters} type="desktop" />
                    <${args.templates.sortOptions} type="dropdown" />
                    <div class="product-count light" role="status">
                      <h2 class="product-count__text text-body">
                        <${args.templates.resultsCountLabel} />
                      </h2>
                    </div>
                  </div>
                </div>

                <!---------- MOBILE FILTERS ---------->
                <${args.templates.mobileFiltersContainer} />
              </div>
              <div class="active-facets-TWP active-facets active-facets-mobile medium-hide large-up-hide">
                <${args.templates.appliedFilters} />
              </div>
            </div>
          `;
          }
        },
        mobileFiltersContainer: {
          render(html, args) {
            const labels = args.labels;
            return html`
            <menu-drawer
              class="mobile-facets__wrapper medium-hide large-up-hide"
              data-breakpoint="mobile"
              data-filters-drawer
            >
              <details class="mobile-facets__disclosure disclosure-has-popup">
                <summary class="mobile-facets__open-wrapper focus-offset">
                  <span class="mobile-facets__open">
                    <${args.templates.icon} type="filters" />

                    <span
                      class="mobile-facets__open-label button-label medium-hide large-up-hide caption--strong"
                      dangerouslySetInnerHTML=${{
              __html: labels.filters.label
            }}
                    >
                    </span>
                    <span class="mobile-facets__open-label button-label small-hide">${labels.filters.buttonLabel}</span>
                  </span>
                  <span tabindex="0" class="mobile-facets__close">
                    <span class="svg-wrapper">
                      <${args.templates.icon} type="close" />
                    </span>
                  </span>
                </summary>
                <div class="facet-filters-form">
                  <div class="mobile-facets">
                    <div class="mobile-facets__inner gradient">
                      <div class="mobile-facets__header">
                        <div class="mobile-facets__header-inner">
                          <h2 class="mobile-facets__heading medium-hide large-up-hide caption--strong">
                            <${args.templates.icon} type="filters" />
                            <span dangerouslySetInnerHTML=${{ __html: labels.filters.label }}></span>
                          </h2>
                          <h2 class="mobile-facets__heading small-hide">${labels.filters.buttonLabel}</h2>
                          <p class="mobile-facets__count"><${args.templates.resultsCountLabel} /></p>
                        </div>
                      </div>

                      <${args.templates.filters} type="mobile" />
                    </div>
                  </div>
                </div>
              </details>
            </menu-drawer>
          `;
          },
          callbacks: {
            afterInitialRender: () => {
              const menuDrawer = widgetElem.querySelector(selectors4.drawer);
              menuDrawer == null ? void 0 : menuDrawer.setAttribute("data-initialized", "");
            }
          }
        },
        filtersVerticalCount: {
          render(html, args) {
            var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
            return html`
            <div class="facets facets-vertical-count small-hide">
              <div class="facets-vertical-form">
                <div class="product-count-vertical" role="status">
                  <h2 class="product-count__text">
                    <${args.templates.resultsCountLabel} />
                  </h2>
                </div>
                <facets-vertical-open>
                  <button
                    class="facets-vertical-open__btn btn-none"
                    type="button"
                    aria-expanded="${showVerticalFilters ? "true" : "false"}"
                    data-facets-vertical-open
                  >
                    <${args.templates.icon} type="filters" />

                    <span class="facets-vertical-open__label facets-vertical-open__label--show caption--strong">
                      ${(_e2 = (_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.filters) == null ? void 0 : _d2.filterButtonShow) != null ? _e2 : "Filter"}
                    </span>

                    <span class="facets-vertical-open__label facets-vertical-open__label--hide caption--strong">
                      ${(_j2 = (_i2 = (_h2 = (_g2 = (_f2 = window.theme) == null ? void 0 : _f2.strings) == null ? void 0 : _g2.search) == null ? void 0 : _h2.filters) == null ? void 0 : _i2.filterButtonHide) != null ? _j2 : "Filter"}
                    </span>
                  </button>
                </facets-vertical-open>
              </div>
            </div>
          `;
          }
        },
        filtersVertical: {
          render(html, args) {
            return html`
            <aside
              class="facets-wrapper facets-wrapper-TWP facets-wrapper-TWP--vertical${showVerticalFilters ? "" : " facets-wrapper-TWP--vertical-hidden"}"
              data-facets-vertical
            >
              <div class="facets small-hide">
                <div class="facets__form-vertical">
                  <${args.templates.filters} type="desktop" />
                </div>
              </div>

              <${args.templates.mobileFiltersContainer} />
            </aside>
          `;
          },
          callbacks: {
            afterInitialRender: () => {
              const facetsVertical = widgetElem.querySelector(selectors4.facetsVertical);
              if (!facetsVertical) return;
              document.dispatchEvent(new CustomEvent("tagalys-search:vertical-filters-ready"));
            }
          }
        },
        filters: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filters = helpers.getFilters();
            if (props.type === "mobile") {
              return html`
              <div id="FacetsWrapperMobile" class="mobile-facets__main has-submenu gradient">
                <${args.templates.sortOptions} type="list" device="mobile" />

                ${filters.map(
                (filter, index) => html`<${args.templates.filterMobile} filter=${filter} index=${index + 1} />`
              )}

                <div class="mobile-facets__footer">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${() => helpers.clearAllFilters()}
                    >
                      ${labels.filters.clearAll}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${(event) => {
                var _a2, _b2;
                (_b2 = (_a2 = event.target.closest(".mobile-facets__wrapper")) == null ? void 0 : _a2.querySelector("summary")) == null ? void 0 : _b2.click();
              }}
                  >
                    ${labels.filters.apply}
                  </button>
                </div>
              </div>
            `;
            }
            return html`
            <div id="FacetsWrapperDesktop" class="facets__wrapper">
              <h2 class="facets__heading caption-large text-body" id="verticalTitle" tabindex="-1">
                ${labels.filters.heading}
              </h2>

              ${filtersType === "vertical" ? html` <${args.templates.sortOptions} type="list" device="desktop" />` : ""}
              ${filters.map((filter, index) => html`<${args.templates.filter} filter=${filter} index=${index + 1} />`)}
            </div>
            ${filtersType !== "vertical" ? html`
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${args.templates.appliedFilters} />
                  </div>
                ` : ""}
          `;
          }
        },
        filterMobile: {
          render(html, args) {
            var _a2, _b2, _c2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filter = props.filter;
            const index = props.index;
            let selectedFiltersLabel = "";
            if (filter.type === "range") {
              const maxPrice = helpers.labelFormatter(filter.display_format, filter.max, filter.currency);
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            const isOpen = defaultExpandedFilters.includes(filter.name.toLowerCase());
            const hasShowMore = filtersType === "vertical" && ((_a2 = filter.items) == null ? void 0 : _a2.length) > showMoreNumber;
            return html`
            <details
              id="Details-Mobile-${filter.id}-search"
              class="mobile-facets__details${isOpen ? " menu-opening" : ""}"
              data-index="mobile-${index}"
              open=${isOpen}
            >
              <summary class="mobile-facets__summary focus-inset caption--strong">
                <div>
                  <span>${filter.name}</span>
                  <span class="mobile-facets__arrow">
                    <${args.templates.icon} type="chevron-down" />
                  </span>
                </div>
              </summary>

              <div
                id="FacetMobile-${index}-search"
                class="mobile-facets__submenu gradient parent-display"
                data-facets-container
              >
                ${filter.type === "range" ? html` <p class="mobile-facets__info">${selectedFiltersLabel}</p>
                      <${args.templates.rangeSliderFilterItem} filter=${filter} />` : html`
                      <div class="parent-wrap">
                        ${filtersType == "vertical" && filter.name.toLowerCase() === searchFilterLabel ? html` <${args.templates.filterSearch} filter=${filter} /> ` : ""}
                        <ul
                          class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled"
                          role="list"
                        >
                          ${(_b2 = filter.items) == null ? void 0 : _b2.map(
              (filterItem, index2) => html`<${args.templates.filterItemMobile}
                                filterItem=${filterItem}
                                index=${index2 + 1}
                                filterId=${filter.id}
                                hasShowMore=${hasShowMore}
                              />`
            )}
                        </ul>
                      </div>
                      ${filtersType === "vertical" && ((_c2 = filter.items) == null ? void 0 : _c2.length) > showMoreNumber ? html` <${args.templates.showMoreButton} filterId=${filter.id} /> ` : ""}
                    `}

                <div class="mobile-facets__footer gradient">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${() => helpers.clearFilter(filter.id)}
                    >
                      ${labels.filters.clear}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${(event) => {
              var _a3, _b3;
              (_b3 = (_a3 = event.target.closest(".mobile-facets__wrapper")) == null ? void 0 : _a3.querySelector("summary")) == null ? void 0 : _b3.click();
            }}
                  >
                    ${labels.filters.apply}
                  </button>
                </div>
              </div>
            </details>
          `;
          }
        },
        filter: {
          render(html, args) {
            var _a2, _b2, _c2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filter = props.filter;
            const index = props.index;
            const selectedFiltersCount = (_a2 = filter.items) == null ? void 0 : _a2.filter((item) => item.selected).length;
            let selectedFiltersLabel = labels.filters.selected.replace("{{ count }}", selectedFiltersCount);
            if (filter.type === "range") {
              const maxPrice = helpers.labelFormatter(filter.display_format, filter.max, filter.currency);
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            const isOpen = filtersType === "vertical" && defaultExpandedFilters.includes(filter.name.toLowerCase());
            if (filter.id == "_derived_field_in_stock") {
              const inStockFilter = (_b2 = filter.items) == null ? void 0 : _b2.find((item) => item.id === "true");
              const onFilterClick = (event) => {
                event.stopPropagation();
                if (inStockFilter.selected) {
                  helpers.clearFilter(filter.id, inStockFilter.id);
                } else {
                  helpers.applyFilter(filter.id, inStockFilter.id);
                }
              };
              if (inStockFilter) {
                return html`
                <div class="facets__summary facets__summary--availability caption--strong">
                  <label class="facet-availablity__wrapper" onclick=${onFilterClick}>
                    <span>${inStockFilter.name}</span>

                    <div class="facet-availablity__switch">
                      <input
                        class="visually-hidden"
                        type="checkbox"
                        name="${filter.id}"
                        value="${inStockFilter.name}"
                        id="Filter-${filter.id}-${inStockFilter.value}"
                        checked=${inStockFilter.selected}
                      />
                      <span class="facet-availability__switch-slider"></span>
                    </div>
                  </label>
                </div>
              `;
              }
            }
            return html`
            <details
              id="Details-${filter.id}-search"
              class="${filtersType === "vertical" ? "facets__disclosure-vertical" : "facets__disclosure disclosure-has-popup"}"
              data-index="${index}"
              open=${isOpen}
            >
              <summary class="facets__summary caption--strong focus-offset">
                <div>
                  <span class="facets__summary-label">${filter.name}</span>
                  <${args.templates.icon} type="caret" />
                </div>
              </summary>

              <div
                id="Facet-${index}-search"
                class="parent-display ${filtersType === "vertical" ? "facets__display-vertical" : "facets__display"}"
                data-facets-container
              >
                ${filtersType !== "vertical" ? html`
                      <div class="facets__header">
                        <div>
                          <span class="facets__selected">${selectedFiltersLabel}</span>
                        </div>

                        <button
                          type="button"
                          class="facets__reset link underlined-link"
                          onClick=${() => helpers.clearFilter(filter.id)}
                        >
                          ${labels.filters.reset}
                        </button>
                      </div>
                    ` : ""}
                ${filtersType == "vertical" && filter.name.toLowerCase() === searchFilterLabel ? html`<${args.templates.filterSearch} filter=${filter} />` : ""}

                <${args.templates.filterItems} filter=${filter} />

                ${filtersType === "vertical" && ((_c2 = filter.items) == null ? void 0 : _c2.length) > showMoreNumber ? html` <${args.templates.showMoreButton} filterId=${filter.id} /> ` : ""}
              </div>
            </details>
          `;
          }
        },
        filterSearch: {
          render(html, args) {
            var _a2, _b2, _c2, _d2, _e2;
            const filter = args.props.filter;
            return html`
            <facets-search class="facets-search">
              <input
                class="facets-search__input caption--strong"
                type="text"
                name="${filter.param_name}-search"
                placeholder="Search"
                data-facets-search-input
              />
              <p class="facets-search__no-results hidden" data-facet-search-no-results>
                ${(_e2 = (_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.filters) == null ? void 0 : _d2.noResults) != null ? _e2 : "No matching results"}
              </p>
            </facets-search>
          `;
          }
        },
        filterItems: {
          render(html, args) {
            var _a2, _b2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const hasShowMore = filtersType === "vertical" && ((_a2 = props.filter.items) == null ? void 0 : _a2.length) > showMoreNumber;
            let selectedFiltersLabel = "";
            if (props.filter.type === "range") {
              const maxPrice = helpers.labelFormatter(
                props.filter.display_format,
                props.filter.max,
                props.filter.currency
              );
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            if (props.filter.type === "checkbox") {
              return html` <fieldset
              class="facets-wrap parent-wrap ${filtersType === "vertical" ? "facets-wrap-vertical" : ""}"
            >
              <legend class="visually-hidden">${props.filter.name}</legend>
              <ul
                class="facets-layout facets-layout-list facets-layout-list--text list-unstyled ${filtersType === "vertical" ? "facets__list--vertical" : "facets__list"}"
                role="list"
              >
                ${(_b2 = props.filter.items) == null ? void 0 : _b2.map(
                (filterItem, index) => html`<${args.templates.filterItem}
                      filterItem=${filterItem}
                      index=${index + 1}
                      filterId=${props.filter.id}
                      hasShowMore=${hasShowMore}
                    />`
              )}
              </ul>
            </fieldset>`;
            }
            if (props.filter.type === "range") {
              return html` ${filtersType === "vertical" ? html`<div class="facets__header-vertical">
                    <span class="facets__selected">${selectedFiltersLabel}</span>
                  </div>` : ""}
              <${args.templates.rangeSliderFilterItem} filter=${props.filter} />`;
            }
          }
        },
        filterItem: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const filterItem = props.filterItem;
            const inputId = `Filter-${props.filterId}-${props.index}`;
            const onFilterClick = (event) => {
              event.stopPropagation();
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
              }
            };
            return html`<li
            class="list-menu__item facets__item${props.hasShowMore && props.index > showMoreNumber ? " show-more-item hidden" : ""}"
            data-facets-item
          >
            <label
              for=${inputId}
              class="facets__label facet-checkbox caption-with-letter-spacing"
              onclick=${onFilterClick}
            >
              <input
                type="checkbox"
                name=${props.filterId}
                value=${filterItem.name}
                id=${inputId}
                checked=${filterItem.selected}
              />

              <${args.templates.icon} type="square" />

              <div class="svg-wrapper">
                <${args.templates.icon} type="checkmark" />
              </div>

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${filterItem.name}</span>
                ${showFilterResultsCount ? `(${filterItem.count})` : ""}
              </span>
            </label>
          </li>`;
          }
        },
        filterItemMobile: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const filterItem = props.filterItem;
            const inputId = `Filter-${props.filterId}-${props.index}`;
            const onFilterClick = (event) => {
              event.stopPropagation();
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
              }
            };
            return html`<li
            class="mobile-facets__item list-menu__item${props.hasShowMore && props.index > showMoreNumber ? " show-more-item hidden" : ""}"
            data-facets-item
          >
            <label
              for=${inputId}
              class="facets__label mobile-facets__label caption-with-letter-spacing"
              onclick=${onFilterClick}
            >
              <input
                class="mobile-facets__checkbox"
                type="checkbox"
                name=${props.filterId}
                value=${filterItem.name}
                id=${inputId}
                checked=${filterItem.selected}
              />

              <span class="mobile-facets__highlight"></span>

              <${args.templates.icon} type="square" />

              <${args.templates.icon} type="checkmark" />

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${filterItem.name}</span>
                ${showFilterResultsCount ? `(${filterItem.count})` : ""}
              </span>
            </label>
          </li>`;
          }
        },
        rangeSliderFilterItem: {
          render(html, args) {
            var _a2, _b2, _c2, _d2;
            const props = args.props;
            const labels = args.labels;
            const inputId = `Filter-${props.filter.name}-`;
            return html`
            <div class="facets__price">
              <div class="hide" ref=${props.sliderRef} />
              <span class="field-currency caption--strong">${(_b2 = (_a2 = window.theme) == null ? void 0 : _a2.localization) == null ? void 0 : _b2.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${inputId}-GTE`}
                  class="field__input"
                  type="number"
                  value=${props.sliderInputValues[0]}
                  onblur=${props.onInputBlur}
                  onchange=${props.onMinChange}
                />
                <label class="field__label caption--strong" for=${`${inputId}-GTE`}>${labels.filters.from}</label>
              </div>
              <span class="field-currency caption--strong">${(_d2 = (_c2 = window.theme) == null ? void 0 : _c2.localization) == null ? void 0 : _d2.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${inputId}-LTE`}
                  class="field__input"
                  type="number"
                  value=${props.sliderInputValues[1]}
                  onblur=${props.onInputBlur}
                  onchange=${props.onMaxChange}
                />
                <label class="field__label caption--strong" for=${`${inputId}-LTE`}>${labels.filters.to}</label>
              </div>
            </div>
          `;
          }
        },
        appliedFilters: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const appliedFilters = helpers.getAppliedFilters(true);
            if (!appliedFilters.length) return "";
            return html`
            ${appliedFilters.map((filter) => {
              var _a2;
              if (filter.type === "range") {
                return html`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${() => helpers.clearFilter(filter.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${helpers.labelFormatter(filter.display_format, filter.selected_min, filter.currency)} -
                      ${helpers.labelFormatter(filter.display_format, filter.selected_max, filter.currency)}
                      <span class="svg-wrapper">
                        <${args.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${labels.filters.clearFilter}</span>
                    </span>
                  </button>
                `;
              }
              return (_a2 = filter.items) == null ? void 0 : _a2.map((item) => {
                return html`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${() => helpers.clearFilter(filter.id, item.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${item.name}
                      <span class="svg-wrapper">
                        <${args.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${labels.filters.clearFilter}</span>
                    </span>
                  </button>
                `;
              });
            })}

            <div class="active-facets__button-wrapper">
              <button
                type="button"
                class="active-facets__button active-facets__button-remove underlined-link btn-none"
                onClick=${() => helpers.clearAllFilters()}
              >
                <span class="active-facets__button-inner">
                  ${labels.filters.clearAll}
                  <span class="svg-wrapper">
                    <${args.templates.icon} type="close-small" />
                  </span>
                </span>
              </button>
            </div>
          `;
          }
        },
        sortOptions: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const sortOptions = helpers.getSortOptions();
            const appliedSortOption = helpers.getAppliedSortOption();
            const applySortOption = (event) => {
              if (event.target.type === "radio" && !event.target.checked) {
                return;
              }
              helpers.applySortOption(event.target.value);
            };
            const isOpen = defaultExpandedFilters.includes(labels.sortOptions.label.toLowerCase());
            if (props.type === "list") {
              return html`
              <details
                id="${props.device === "desktop" ? "Details-sortby-search" : "Details-Mobile-SortBy-search"}"
                class="${props.device === "desktop" ? "facets__disclosure-vertical" : "mobile-facets__details menu-opening"}"
                open=${isOpen}
              >
                <summary
                  class="${props.device === "desktop" ? "facets__summary" : "mobile-facets__summary"} focus-inset caption--strong"
                  aria-label="${labels.sortOptions.label} ${appliedSortOption.label}"
                >
                  <div>
                    <span class="facets__summary-label">${labels.sortOptions.label}</span>
                    ${props.device === "desktop" ? html` <${args.templates.icon} type="caret" /> ` : html`<span class="mobile-facets__arrow">
                          <${args.templates.icon} type="chevron-down" />
                        </span>`}
                  </div>
                </summary>

                <div class="${props.device === "desktop" ? "facets__display-vertical" : "mobile-facets__submenu"}">
                  <ul class="facets-layout facets-layout-list list-unstyled">
                    ${sortOptions.map(
                (sortOption) => html` <${args.templates.sortOptionListItem}
                          sortOption=${sortOption}
                          applySortOption=${applySortOption}
                          device=${props.device}
                        />`
              )}
                  </ul>
                </div>
              </details>
            `;
            }
            if (props.type === "dropdown") {
              return html`
              <div class="facet-filters sorting caption">
                <div class="facet-filters__field">
                  <h2 class="facet-filters__label caption-large text-body">
                    <label for="SortBy">${labels.sortOptions.label}</label>
                  </h2>
                  <div class="select">
                    <select
                      class="facet-filters__sort select__select caption-large"
                      id="SortBy"
                      name="sort_by"
                      value=${appliedSortOption.id}
                      onchange=${applySortOption}
                    >
                      ${sortOptions.map(
                (sortOption) => html` <option value=${sortOption.id}>${sortOption.label}</option>`
              )}
                    </select>

                    <span class="svg-wrapper">
                      <${args.templates.icon} type="chevron-down" />
                    </span>
                  </div>
                </div>
              </div>
            `;
            }
          }
        },
        sortOptionListItem: {
          render(html, args) {
            const props = args.props;
            const sortOption = props.sortOption;
            return html`
            <li class="list-menu__item facets__item">
              <label
                for=${`SortBy-${sortOption.id}-${props.device}`}
                class="facets__label facet-checkbox caption-with-letter-spacing"
              >
                <input
                  id=${`SortBy-${sortOption.id}-${props.device}`}
                  class="visually-hidden"
                  type="radio"
                  name="sort_by"
                  value=${sortOption.id}
                  ${sortOption.selected ? "checked" : ""}
                  onchange=${props.applySortOption}
                />
                <${args.templates.icon} type="square" />
                <div class="svg-wrapper">
                  <${args.templates.icon} type="checkmark" />
                </div>
                ${sortOption.label}
              </label>
            </li>
          `;
          }
        },
        resultsCountLabel: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const totalProductsCount = helpers.getTotalProductsCount();
            const resultsLabelTemplate = totalProductsCount === 1 ? labels.resultsWithCount.one : labels.resultsWithCount.other;
            const resultsLabel = resultsLabelTemplate == null ? void 0 : resultsLabelTemplate.replace("{{ count }}", totalProductsCount);
            return html`${resultsLabel}`;
          }
        },
        products: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const products = helpers.getProducts();
            return html`
            <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
              ${products.map((product) => html`<${args.templates.product} key=${product.id} product=${product} />`)}
            </ul>
          `;
          }
        },
        product: {
          render(html, args) {
            const props = args.props;
            const product = props.product;
            const helpers = props.helpers;
            return html`<li
            class="grid__item scroll-trigger animate--slide-in"
            dangerouslySetInnerHTML=${{ __html: product_card_render_default(product, helpers) }}
          />`;
          }
        },
        productListFooter: {
          render(html, args) {
            return html` <${args.templates.pagination} /> `;
          }
        },
        pagination: {
          render(html, args) {
            return html`
            <div class="pagination-wrapper">
              <nav class="pagination" role="navigation" aria-label="Pagination">
                <${args.templates.paginationLinks} />
              </nav>
            </div>
          `;
          }
        },
        paginationLinks: {
          options: {
            showNumberedPageLinks: true,
            numberedPageLinksWindowSize: 3,
            showPreviousPageLink: true,
            showFirstPageLink: false,
            showNextPageLink: true,
            scrollTop: true
          },
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const pagesToDisplay = helpers.getPagesToDisplay(props.numberedPageLinksWindowSize);
            const hasPreviousPage = helpers.hasPreviousPage();
            const hasNextPage = helpers.hasNextPage();
            return html`
            <ul class="pagination__list list-unstyled" role="list">
              ${props.showPreviousPageLink && hasPreviousPage ? html` <li>
                    <button
                      type="button"
                      class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                      aria-label="Previous page"
                      onclick=${helpers.goToPreviousPage}
                    >
                      <span class="svg-wrapper">
                        <${args.templates.icon} type="caret" />
                      </span>
                    </button>
                  </li>` : null}
              ${props.showNumberedPageLinks ? pagesToDisplay.map((pageDetail) => {
              const classes2 = ["pagination__item link"];
              const isEllipsis = pageDetail.jumpAfter;
              if (pageDetail.current) classes2.push("pagination__item--current");
              const className = classes2.join(" ");
              if (isEllipsis) {
                return html`
                        <li>
                          <span class="pagination__item tt">...</span>
                        </li>
                      `;
              }
              return html`
                      <li>
                        <button
                          type="button"
                          class=${`${className}`}
                          onclick=${() => {
                helpers.goToPage(pageDetail.page);
              }}
                        >
                          ${pageDetail.page}
                        </button>
                      </li>
                    `;
            }) : null}
              ${props.showNextPageLink && hasNextPage ? html`
                    <li>
                      <button
                        type="button"
                        class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                        aria-label="Next page"
                        onclick=${helpers.goToNextPage}
                      >
                        <span class="svg-wrapper">
                          <${args.templates.icon} type="caret" />
                        </span>
                      </button>
                    </li>
                  ` : null}
            </ul>
          `;
          }
        },
        showMoreButton: {
          render(html, args) {
            var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2;
            const props = args.props;
            return html`<show-more-button>
            <button
              class="button-show-more link underlined-link caption--strong"
              id="Show-More-${props.filterId}-tagalys-search"
              type="button"
            >
              <span class="label-show-more label-text">
                ${(_e2 = (_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.filters) == null ? void 0 : _d2.showMore) != null ? _e2 : "Show More"}
              </span>
              <span class="label-show-less label-text hidden">
                ${(_j2 = (_i2 = (_h2 = (_g2 = (_f2 = window.theme) == null ? void 0 : _f2.strings) == null ? void 0 : _g2.search) == null ? void 0 : _h2.filters) == null ? void 0 : _i2.showLess) != null ? _j2 : "Show Less"}
              </span>
            </button>
          </show-more-button>`;
          }
        },
        noResults: {
          options: {
            widgets: [
              {
                widgetId: noResultsWidgetId,
                options: {
                  templates: tagalys_widget_templates_default(noResultsWidgetLimit, widgetElem),
                  callbacks: {
                    afterInitialRender: () => {
                      const sliderComponent = widgetElem.querySelector("slider-component");
                      sliderComponent == null ? void 0 : sliderComponent.reinitialiseSlider();
                    }
                  }
                }
              }
            ]
          },
          render(html, args) {
            return html`
            <${args.templates.header} />

            ${noResultsWidgetId ? html`
                  <div class="product-recommendations__wrapper">
                    <${args.templates.noResultsWidgets} />
                  </div>
                ` : ""}
          `;
          }
        },
        icon: {
          render(html, args) {
            const props = args.props;
            if (props.type === "filters") {
              return html`<svg
              class="icon icon-filters"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="none"
              viewBox="0 0 13 13"
            >
              <g fill="currentColor" clip-path="url(#a)">
                <path
                  fill-rule="evenodd"
                  d="M11.665.83H1.077v10.59h10.588V.83ZM.371.126v12h12v-12h-12Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M3.444 4.949h4.197a.824.824 0 1 0 0-.706H3.444v.706ZM4.268 8.83a.824.824 0 0 0 .744-.47h4.197v-.706H5.012a.824.824 0 1 0-.744 1.177Z"
                />
              </g>
              <defs>
                <clipPath id="a"><path fill="#fff" d="M0 .125h13v12H0z" /></clipPath>
              </defs>
            </svg>`;
            }
            if (props.type === "caret") {
              return html`<svg class="icon icon-caret" viewBox="0 0 10 6">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                clip-rule="evenodd"
              />
            </svg> `;
            }
            if (props.type === "chevron-down") {
              return html`<svg
              class="icon icon-chevron-down"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4 6L8 10L12 6" stroke="currentColor" />
            </svg> `;
            }
            if (props.type === "square") {
              return html`<svg width="16px" height="16px" viewBox="0 0 16 16">
              <rect width="16" height="16" fill="none" stroke="currentColor" />
            </svg>`;
            }
            if (props.type === "checkmark") {
              return html`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-checkmark"
              viewBox="0 0 12 9"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                clip-rule="evenodd"
              />
            </svg> `;
            }
            if (props.type === "close") {
              return html`<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
              <path
                fill="currentColor"
                d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
              />
            </svg>`;
            }
            if (props.type === "close-small") {
              return html`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-close-small"
              viewBox="0 0 12 13"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
              />
            </svg>`;
            }
          }
        }
      },
      callbacks: {
        onSuccessfulAPICall: (response) => {
          var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
          const totalResults = response.total;
          const metaTitleTemplate = totalResults > 0 ? `${(_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.metaTitle) == null ? void 0 : _d2.results} - ${window.shopName}` : `${(_h2 = (_g2 = (_f2 = (_e2 = window.theme) == null ? void 0 : _e2.strings) == null ? void 0 : _f2.search) == null ? void 0 : _g2.metaTitle) == null ? void 0 : _h2.noResults} - ${window.shopName}`;
          const metaTitle = metaTitleTemplate.replace("{{ count }}", totalResults).replace("{{ term }}", response.query);
          document.title = decodeHtmlEntities(metaTitle);
          return response;
        }
      }
    });
  };
  var initTagalysSearchResults = (container) => {
    onTagalysReady(() => {
      tagalysSearchResults(container);
    });
  };

  // src/scripts/components/facets-vertical-open.js
  var initFacetsVerticalOpenElement = () => {
    class FacetsVerticalOpen extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          facetsVertical: "[data-facets-vertical]"
        };
        this.classes = {
          facetsVerticalAreOpen: "facets-vertical-are-open",
          facetsHidden: "facets-wrapper-TWP--vertical-hidden"
        };
      }
      connectedCallback() {
        var _a, _b;
        this.button = this.querySelector("button");
        this.facetsVertical = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.querySelector(this.selectors.facetsVertical);
        if (this.facetsVertical) {
          this.setInitialState();
        } else {
          document.addEventListener(
            "tagalys-search:vertical-filters-ready",
            () => {
              var _a2;
              this.facetsVertical = (_a2 = this.closest(".shopify-section")) == null ? void 0 : _a2.querySelector(this.selectors.facetsVertical);
              if (this.facetsVertical) this.setInitialState();
            },
            { once: true }
          );
        }
        (_b = this.button) == null ? void 0 : _b.addEventListener("click", (event) => {
          var _a2;
          event.preventDefault();
          this.isOpen = !((_a2 = this.facetsVertical) == null ? void 0 : _a2.classList.contains(this.classes.facetsHidden));
          this.toggleFacetsVerticalVisibility(!this.isOpen);
          sessionStorage.setItem("facetsVerticalOpen", !this.isOpen);
        });
      }
      setInitialState() {
        var _a;
        this.isOpen = !((_a = this.facetsVertical) == null ? void 0 : _a.classList.contains(this.classes.facetsHidden));
        this.facetsVerticalState = sessionStorage.getItem("facetsVerticalOpen") ? JSON.parse(sessionStorage.getItem("facetsVerticalOpen")) : this.isOpen;
        this.toggleFacetsVerticalVisibility(this.facetsVerticalState);
      }
      toggleFacetsVerticalVisibility(open) {
        var _a, _b;
        (_a = this.button) == null ? void 0 : _a.setAttribute("aria-expanded", open);
        (_b = this.facetsVertical) == null ? void 0 : _b.classList.toggle(this.classes.facetsHidden, !open);
        document.body.classList.toggle("facets-vertical-are-open", open);
      }
    }
    customElements.define("facets-vertical-open", FacetsVerticalOpen);
  };
  var facets_vertical_open_default = initFacetsVerticalOpenElement;

  // src/scripts/utils/debounce.js
  var debounce = (callback, delay = 250) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        timeoutId = null;
        callback(...args);
      }, delay);
    };
  };

  // src/scripts/components/facets-search.js
  var initFacetsSearch = () => {
    class FacetsSearch extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "debouncedSearch", debounce(() => {
          var _a, _b;
          const searchValue = this.facetsSearchInput.value;
          if (this.listItems.length < 1) return;
          let resultsCount = 0;
          this.listItems.forEach((item) => {
            var _a2;
            const label = item.querySelector(this.selectors.facetLabel);
            const labelText = ((_a2 = label == null ? void 0 : label.textContent) == null ? void 0 : _a2.toLowerCase()) || "";
            if (searchValue === "" || labelText.includes(searchValue)) {
              item.classList.remove("hidden");
              resultsCount++;
            } else {
              item.classList.add("hidden");
            }
          });
          const noResults = (_a = this.facetsContainer) == null ? void 0 : _a.querySelector(this.selectors.noSearchResults);
          noResults == null ? void 0 : noResults.classList.toggle("hidden", resultsCount > 0);
          const showMoreButton = (_b = this.facetsContainer) == null ? void 0 : _b.querySelector(this.selectors.facetsShowMoreButton);
          showMoreButton == null ? void 0 : showMoreButton.classList.toggle("hidden", resultsCount <= this.showMoreNumber);
        }, 250));
        this.selectors = {
          facetsContainer: "[data-facets-container]",
          facetsItem: "[data-facets-item]",
          facetLabel: "[data-facet-label]",
          facetSearchInput: "[data-facets-search-input]",
          noSearchResults: "[data-facet-search-no-results]",
          facetsShowMoreButton: "show-more-button"
        };
        this.classes = {
          hidden: "hidden"
        };
      }
      connectedCallback() {
        var _a, _b, _c;
        this.facetsSearchInput = this.querySelector(this.selectors.facetSearchInput);
        this.facetsContainer = (_a = this.facetsSearchInput) == null ? void 0 : _a.closest(this.selectors.facetsContainer);
        this.listItems = (_b = this.facetsContainer) == null ? void 0 : _b.querySelectorAll(this.selectors.facetsItem);
        this.showMoreNumber = window.matchMedia("(min-width: 990px)").matches ? 10 : 5;
        (_c = this.facetsSearchInput) == null ? void 0 : _c.addEventListener("input", this.debouncedSearch);
      }
      disconnectedCallback() {
        var _a;
        (_a = this.facetsSearchInput) == null ? void 0 : _a.removeEventListener("input", this.debouncedSearch);
      }
    }
    customElements.define("facets-search", FacetsSearch);
  };
  var facets_search_default = initFacetsSearch;

  // src/scripts/components/autoplay-video.js
  var AutoplayVideo = class extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        video: "video",
        control: "[data-video-control]"
      };
      this.classes = {
        playing: "autoplay-video__control--playing"
      };
    }
    connectedCallback() {
      var _a, _b;
      this.video = this.querySelector(this.selectors.video);
      this.control = this.querySelector(this.selectors.control);
      (_a = this.control) == null ? void 0 : _a.addEventListener("click", this.togglePlayPause.bind(this));
      (_b = this.video) == null ? void 0 : _b.addEventListener("click", () => {
        if (window.matchMedia("(min-width: 750px)").matches) return;
        this.togglePlayPause();
      });
    }
    togglePlayPause() {
      if (!this.video) return;
      if (this.video.paused) {
        this.video.play();
        this.control.classList.add(this.classes.playing);
      } else {
        this.video.pause();
        this.control.classList.remove(this.classes.playing);
      }
    }
  };
  customElements.define("autoplay-video", AutoplayVideo);

  // node_modules/lazyvids/dist/lazyvids.js
  ((t) => {
    window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach), document.addEventListener("DOMContentLoaded", () => {
      var w, f, h, z, m, L;
      const r = { logLevel: (w = t == null ? void 0 : t.logLevel) != null ? w : "silent", ignoreHidden: (f = t == null ? void 0 : t.ignoreHidden) != null ? f : false, minBandwidth: (t == null ? void 0 : t.minBandwidth) ? Number(t.minBandwidth) : 0, reduceData: (h = t == null ? void 0 : t.reduceData) != null ? h : false }, E = (e, a = "") => {
        r.logLevel === "verbose" && window.console.log(`lazyvids: ${e}`, a);
      }, i = (e, a = "") => {
        r.logLevel !== "silent" && window.console.warn(`lazyvids: ${e}`, a);
      }, u = typeof window.IntersectionObserver == "function";
      let y;
      if (r.reduceData && r.minBandwidth && (((z = navigator.connection) == null ? void 0 : z.downlink) < r.minBandwidth || ((m = navigator.connection) == null ? void 0 : m.saveData))) {
        i(`Slow connection (${(L = navigator.connection) == null ? void 0 : L.downlink}mbps). Lazy autoplay disabled.`);
        return;
      }
      const c = (e) => {
        e.muted = true, e.autoplay = true, e.play() !== void 0 ? e.play().then(() => e.dataset.lazyvids = "loaded").catch((a) => i("Autoplay blocked by browser for:", e)) : e.dataset.lazyvids = "loaded";
      }, v = (e) => {
        var n, d;
        if (((n = e.style) == null ? void 0 : n.display) === "none" || r.ignoreHidden && ((d = e.style) == null ? void 0 : d.visibility) === "hidden") return false;
        const a = getComputedStyle(e);
        return a.getPropertyValue("display") === "none" || r.ignoreHidden && a.getPropertyValue("visibility") === "hidden" ? false : e.parentNode && e.parentNode !== document ? v(e.parentNode) : true;
      }, N = (e, a) => {
        e.forEach((s) => {
          window.requestAnimationFrame(() => {
            const n = s.target;
            s.isIntersecting !== false && v(n) !== false && (c(n), a.unobserve(n));
          });
        });
      };
      u && (y = new IntersectionObserver(N));
      const o = (e) => {
        if (u === false) {
          c(e), i("Unsupported browser. Lazy autoplay disabled.");
          return;
        }
        e.dataset.lazyvids = "unloaded", y.observe(e);
      }, p = "video[data-lazyvids]:not([data-lazyvids=loaded]):not([data-lazyvids=false])", l = document.querySelectorAll(p);
      E(`Initialised \u2014 ${l.length} ${l.length === 1 ? "video" : "videos"} detected`), l.forEach((e) => o(e));
      const I = (e) => {
        e.forEach((a) => {
          a.addedNodes.forEach((s) => {
            if (s.tagName === "VIDEO" && s.dataset.lazyvids !== void 0 && s.dataset.lazyvids !== "loaded" && s.dataset.lazyvids !== "false") {
              o(s);
              return;
            }
            if (s.hasChildNodes() === false) return;
            s.querySelectorAll(p).forEach((d) => o(d));
          });
        });
      }, D = { childList: true, subtree: true };
      new MutationObserver(I).observe(document, D);
    });
  })(window.lazyvidsConfig || {});

  // src/scripts/layout/theme.js
  var selectors5 = {
    shopifySections: ".shopify-section",
    tagalysSearchResults: '[data-tagalys-widget="search-results"]'
  };
  var classes = {
    header: "section-header",
    productRecommendations: "product-recommendations-recently",
    sectionCollection: "section-collection",
    sectionSearch: "main-search"
  };
  document.addEventListener("DOMContentLoaded", () => {
    initCustomTabs();
    initTagalys();
    onTagalysReady(() => {
      var _a;
      if (((_a = window.Tagalys) == null ? void 0 : _a.Analytics) && typeof window.Tagalys.Analytics.trackPlatformEvents === "function") {
        window.Tagalys.Analytics.trackPlatformEvents();
      }
    });
    initTagalysSearchSuggestions();
    const shopifySections = document.querySelectorAll(selectors5.shopifySections);
    shopifySections.forEach((section) => {
      if (section.classList.contains(classes.header)) {
        header_default(section);
        return;
      }
      if (section.classList.contains(classes.productRecommendations)) {
        productRecommendations(section);
        return;
      }
      if (section.classList.contains(classes.sectionCollection) || section.classList.contains(classes.sectionSearch)) {
        facets_vertical_open_default();
        facets_search_default();
      }
      if (section.querySelector(selectors5.tagalysSearchResults)) {
        initTagalysSearchResults(section);
      }
    });
    document.addEventListener("shopify:section:load", (event) => {
      const sectionId = event.detail.sectionId;
      if (sectionId.includes("product_recommendations")) {
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (!section) return;
        productRecommendations(section);
      }
    });
    const copyButtons = document.querySelectorAll("[data-copy-button]");
    copyButtons.forEach((button) => {
      button.addEventListener("click", () => __async(void 0, null, function* () {
        let text = button.dataset.copyButton;
        if (!text) return;
        try {
          yield navigator.clipboard.writeText(text);
          button.disabled = true;
          setTimeout(() => {
            button.disabled = false;
          }, 1500);
        } catch (err) {
          window.console.error("Failed to copy text: ", err);
        }
      }));
    });
  });
})();
